import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import BoothAPI from "./api/BoothAPI";
import VisitorProfileAPI from "./api/VisitorProfileAPI";
import ReportAPI from "./api/ReportAPI";
import CustomAlert from "./common/sweetAlert";
import 'beautify-scrollbar/dist/index.css';
import 'v2-table/dist/index.css';
import i18n from './common/i18n'
import V2Table from 'v2-table';
import VerifyAPI from "@/api/VerifyAPI";
import ShowInfoAPI from "@/api/ShowInfoAPI";

//import {BootstrapVue, IconsPlugin} from "bootstrap-vue";
//import "bootstrap/dist/css/bootstrap.css";
//import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.config.productionTip = true;
Vue.config.devtools = true;
Vue.config.debug = true;
Vue.config.productionSourceMap = true;
Vue.config.silent = true;

Vue.use(BoothAPI);
Vue.use(ReportAPI);
Vue.use(VisitorProfileAPI);
Vue.use(CustomAlert);
Vue.use(V2Table);
Vue.use(VerifyAPI);
Vue.use(ShowInfoAPI);

//Vue.use(BootstrapVue);
//Vue.use(IconsPlugin);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
